import { withStyles } from '@material-ui/core/styles';

const GlobalStyles = withStyles((theme) => ({
  // @global is handled by jss-plugin-global.
  '@global': {
    html: {
      WebkitFontSmoothing: 'subpixel-antialiased', // Antialiasing.
      MozOsxFontSmoothing: 'grayscale', // Antialiasing.
      boxSizing: 'border-box',
      // Fix font resize problem in iOS
      WebkitTextSizeAdjust: '100%',
    },
    '*, *::before, *::after': {
      boxSizing: 'inherit',
    },
    body: {
      margin: '0',
      padding: '0',
      fontFamily:
        "apple-system, system-ui, 'Segoe UI', Arial, Helvetica, Roboto, sans-serif",
      fontSize: '14px',
      backgroundColor: theme.palette.xpl.background,
      '&::backdrop': {
        backgroundColor: theme.palette.xpl.background,
      },
    },
    a: {
      textDecoration: 'none',
      cursor: 'pointer',
      color: 'inherit',
    },
    ul: {
      listStyle: 'none',
    },
    input: {
      '&:focus': {
        outline: 'none',
      },

      '&::-webkit-input-placeholder': {
        /* Chrome/Opera/Safari */
        color: '#b3b3b3 !important',
        opacity: '1 !important',
        fontSize: '14px',
      },
      '&::-moz-placeholder': {
        /* Firefox 19+ */
        color: '#b3b3b3 !important',
        opacity: '1 !important',
        fontSize: '14px',
      },
      '&:-ms-input-placeholder': {
        /* IE 10+ */
        color: '#b3b3b3 !important',
        opacity: '1 !important',
        fontSize: '14px',
      },
      '&:-moz-placeholder': {
        /* Firefox 18- */
        color: '#b3b3b3 !important',
        opacity: '1 !important',
        fontSize: '14px',
      },
    },
  },
}))(() => null);

export default GlobalStyles;
